export enum eSplitClosing {
  no = 'no',
  buyer = 'buyer',
  seller = 'seller',
}

export const DisplaySplitClosing = {
  [eSplitClosing.no]: 'No',
  [eSplitClosing.buyer]: 'Yes - Buyer',
  [eSplitClosing.seller]: 'Yes - Seller',
};
